import React from "react"
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa"

import { productUnitsSymbol } from "constant"
import classes from "./StrrdmResponseTableRow.module.scss"

const StrrdmResponseTableRow = (props) => {
  const { requestedItem } = props

  const isItemAccepted =
    requestedItem.acceptedQuantity > 0

  const backgroundColor =
    isItemAccepted
      ? "var(--color-success-alpha-25)"
      : "var(--color-danger-alpha-25)"

  return (
    <tr style={{ backgroundColor }} >
      <td>
        {isItemAccepted
          ?
          <FaCheckCircle
            size={16}
            className={classes["check"]}
          />
          :
          <FaTimesCircle
            size={16}
            className={classes["times"]}
          />
        }
      </td>
      <td>
        {requestedItem.foodName}{" "}
        {requestedItem.isSimple ? "" : requestedItem.foodOptionName}
      </td>
      <td style={{ textAlign: "center" }}>
        {requestedItem.requestedQuantity}
        {productUnitsSymbol[requestedItem.unit]}
      </td>
      <td style={{ textAlign: "center" }}>
        {requestedItem.acceptedQuantity}{productUnitsSymbol[requestedItem.unit]}
      </td>
    </tr>
  )
}

export default StrrdmResponseTableRow